import { SSEClientManager } from "@/shared/services/SSEClientManager";
import { baseURL, endpoints } from ".";

const equitiesSSEClient = new SSEClientManager({
  endpoint: baseURL + endpoints.streamData,
  connectionName: "Equities-SSE",
  // Backend emits `event: ping` keepalives every ~20s. 45s is the recommended
  // 2× heartbeat + buffer threshold for treating the stream as stalled.
  activityTimeoutMs: 45000,
});

export default equitiesSSEClient;
